function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

var CountryLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CountryLink, _React$Component);

  function CountryLink() {
    _classCallCheck(this, CountryLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(CountryLink).apply(this, arguments));
  }

  _createClass(CountryLink, [{
    key: "countryLinkUrl",
    value: function countryLinkUrl() {
      return "/countries/".concat(this.props.country.properties.code);
    }
  }, {
    key: "render",
    value: function render() {
      var label = this.props.country.properties.name;
      return React.createElement("li", null, label === 'Nicaragua' ? React.createElement(Link, {
        to: this.countryLinkUrl()
      }, label) : React.createElement(Link, {
        to: '/search'
      }, label));
    }
  }]);

  return CountryLink;
}(React.Component);

CountryLink.propTypes = {
  country: PropTypes.object.isRequired
};
export { CountryLink as default };
export var CountryDropdown =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(CountryDropdown, _React$Component2);

  function CountryDropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CountryDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CountryDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      open: false
    };

    _this.handleClick = function () {
      _this.setState({
        open: !_this.state.open
      });
    };

    return _this;
  }

  _createClass(CountryDropdown, [{
    key: "render",
    value: function render() {
      var classNameDropDown = 'country-link-list';

      if (this.state.open) {
        classNameDropDown = 'country-link-list active';
      }

      return React.createElement("div", {
        id: "country-link-list",
        className: classNameDropDown,
        role: "button",
        tabIndex: "0",
        onKeyPress: function onKeyPress() {},
        onClick: this.handleClick
      }, "Pick a country to get started", React.createElement("ul", {
        className: "dropdown"
      }, this.props.children));
    }
  }]);

  return CountryDropdown;
}(React.Component);
CountryDropdown.propTypes = {
  children: PropTypes.node.isRequired
};